import React, {useEffect} from "react";
import {useLocation} from "react-router-dom";
import {initAnalytics, trackPageView} from "../../utils/analytics";

/**
 * Initializes GA4 once and sends SPA page views + feature_access on route changes.
 */
const AnalyticsTracker: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    initAnalytics();
  }, []);

  useEffect(() => {
    trackPageView(location.pathname, location.search);
  }, [location.pathname, location.search]);

  return null;
};

export default AnalyticsTracker;
